import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Container = styled.div`
  width: 100%;
  height: 100px;
`;

const DemoExpandedItem = ({ text }) => {
  return (
    <Container>
      Hello {text}
    </Container>
  );
};

DemoExpandedItem.propTypes = {
  text: PropTypes.string,
};

DemoExpandedItem.defaultProps = {
  text: 'John',
};

export default DemoExpandedItem;
